import axios from 'axios';
import {BASE_URL, URL_APP_SETTINGS, URL_APP_SET_CITY_SETTING, URL_LOGOUT, URL_APP_AUTH_URL, URL_APP_USER_INFO} from '../utils/Constant';

export function init(params) {
  return axios
    .get(BASE_URL + URL_APP_SETTINGS, {params})
    .then((r) => r.data);
}

export function setCity(city) {
  return axios
    .post(BASE_URL + URL_APP_SET_CITY_SETTING, {city})
    .then((r) => r.data);
}

export function logout() {
  return axios.post(URL_LOGOUT);
}

export async function getUrl() {
  const r = await axios
    .get(BASE_URL + URL_APP_AUTH_URL);
  return r.data;
}

export async function getUser() {
  const r = await axios
    .get(URL_APP_USER_INFO);
    return r.data;
}